import { render, staticRenderFns } from "./VuesticSidebar.vue?vue&type=template&id=3b907b56&"
import script from "./VuesticSidebar.vue?vue&type=script&lang=js&"
export * from "./VuesticSidebar.vue?vue&type=script&lang=js&"
import style0 from "./VuesticSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticSidebar.vue"
export default component.exports